import { render, staticRenderFns } from "./AccreditedBuilder.vue?vue&type=template&id=cb3c899c"
import script from "./AccreditedBuilder.vue?vue&type=script&lang=ts"
export * from "./AccreditedBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports